import { provinceTranslations } from '../components/region-selectors/shared/utils/province-translations';
import { ProvinceResponse } from '../stores/business-unit';

/** The labels of a region's tags: three provinces at most, then how many more. */
export const getProvinceNameTags = (names: string[]) => {
    let provincesNames = names.map(
        (name) => provinceTranslations[name.toUpperCase()]
    );

    if (provincesNames.length === 0) {
        return null;
    }

    if (provincesNames.length > 3) {
        const remainingProvinces = provincesNames.length - 3;
        provincesNames = [
            ...provincesNames.slice(0, 3),
            `+${remainingProvinces}`,
        ];
    }

    return provincesNames;
};

export const getProvincesTags = (provinces: ProvinceResponse[]) =>
    getProvinceNameTags(provinces.map((ep) => ep.province.name));
